import { Routes, Route, Navigate } from 'react-router-dom';
import Home from './components/Home';
import AcademicWritings from './components/AcademicWritings';
import EssayView from './components/EssayView';
import Music from './components/Music';
import LittleThings from './components/LittleThings';
import Photos from './components/Photos';
import Headspace from './components/headspace/Headspace';
import { AdminProvider } from './context/AdminContext';
import Layout from './components/Layout';
import { AuthProvider } from './context/AuthContext';
import LoginPage from './components/headspace/LoginPage';

function App() {
    return (
        <AuthProvider>
            <AdminProvider>
                <Routes>
                    <Route element={<Layout />}>
                        <Route path="/" element={<Home />} />
                        <Route path="/academic-writings" element={<AcademicWritings />} />
                        <Route path="/academic-writings/:slug" element={<EssayView />} />
                        <Route path="/music" element={<Music />} />
                        <Route path="/little-things" element={<LittleThings />} />
                        <Route path="/photos" element={<Photos />} />
                    </Route>
                    <Route path="/headspace" element={<Headspace />} />
                    <Route path="/login" element={<LoginPage />} />
                    {/* keep old links alive */}
                    <Route path="/writing" element={<Navigate to="/academic-writings" replace />} />
                    <Route path="/writing/:id" element={<Navigate to="/academic-writings" replace />} />
                    <Route path="*" element={<Navigate to="/" />} />
                </Routes>
            </AdminProvider>
        </AuthProvider>
    );
}

export default App;